export const formatByDegree = (degree: number): string => {
  if (degree > 0) {
    return `+${degree}`;
  }
  return degree.toString();
};

export const isValidTemperature = (
  temperature: unknown
): temperature is number => {
  if (typeof temperature !== "number") return false;

  if (Number.isNaN(temperature)) return false;

  return temperature === 0 || Boolean(temperature);
};
